import { render, staticRenderFns } from "./KonvaCampaignContextMenu.vue?vue&type=template&id=c4954e20&scoped=true"
import script from "./KonvaCampaignContextMenu.vue?vue&type=script&lang=js"
export * from "./KonvaCampaignContextMenu.vue?vue&type=script&lang=js"
import style0 from "./KonvaCampaignContextMenu.vue?vue&type=style&index=0&id=c4954e20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4954e20",
  null
  
)

export default component.exports